import React, { useEffect, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import RouteDropdown from "../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaEye } from "react-icons/fa";
import { RiPencilFill } from "react-icons/ri";
import { useStpListData } from "./hooks/useSTP";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import STPEditModal from "./components/STPEditModal";
import { BASE_URL } from "../../Api/config";
import { downloadExcelGet } from "../../utils/ExcelDownload";

const STPListColumns = (
  handleEditSTPColumns: (row: any) => void,
  handleView: (row: any) => void
) => [
  {
    name: "Position Name",
    selector: (row: { PositionName: string }) => row.PositionName || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Emp Name | Emp Code",
    selector: (row: { EmployeeName: string | any }) => row?.EmployeeName || "-",
    sortable: true,
    maxWidth: "250px",
    wrap: true,
  },
  {
    name: "Status",
    selector: (row: { StpStatus: string | any }) =>
      row?.StpStatus
        ? row?.StpStatus?.charAt(0)?.toUpperCase() + row?.StpStatus?.slice(1)
        : "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  // {
  //   name: "Applied From",
  //   selector: (row: { AppliedFromDate: string | any }) =>
  //     row?.AppliedFromDate || "-",
  //   sortable: true,
  //   width: "150px",
  //   wrap: true,
  // },
  // {
  //   name: "Applied Till",
  //   selector: (row: { AppliedToDate: string | any }) =>
  //     row?.AppliedToDate || "-",
  //   sortable: true,
  //   width: "150px",
  //   wrap: true,
  // },
  {
    name: "Approved By",
    selector: (row: { StpApprovedByName: string | any }) =>
      row?.StpApprovedByName || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Approved Date",
    selector: (row: { ApprovedDate: string | any }) => row?.ApprovedDate || "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string | any }) => row?.CreatedAt || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Updated At",
    selector: (row: { UpdatedAt: string | any }) => row?.UpdatedAt || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Actions",
    cell: (row: any) => (
      <div className="d-flex align-items-center" style={{}}>
        <div className="d-flex align-items-center">
          <button
            onClick={() => handleEditSTPColumns(row)}
            className="btn btn-primary"
            style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
          </button>
        </div>
        <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
          <button
            onClick={() => handleView(row)}
            className="btn btn-primary"
            style={{
              borderRadius: "20px",
              padding: "2px",
              width: "100px",
              backgroundColor: "#2e8dd3",
            }}
          >
            <FaEye style={{ fill: "#fff" }} />
            View Plan
          </button>
        </div>
      </div>
    ),
    width: "220px",
  },
];
const STP: React.FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [paginationStates, setPaginationStates] = useState<any>({
    length: 10,
    start: 1,
    search: null,
    sortColumn: "CreatedAt",
    sortOrder: "asc",
  });
  const [rowData, setRowData] = useState(null);
  const { data } = useStpListData({
    enable: true,
    params: {
      length: paginationStates.length,
      start: paginationStates.start,
      search: paginationStates.search,
      sortColumn: paginationStates.sortColumn,
      sortOrder: paginationStates.sortOrder,
    },
  });

  const [disable, setdisabled] = useState<boolean>(false);
  const handleEditSTPColumns = (row: any) => {
    setRowData(row);
    setIsModalOpen(true);
  };
  const handleView = (row: any) => {
    navigate("/stpview", { state: { stpRowData: row } });
  };
  const toggleModal = () => {
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPaginationStates((prevState: any) => {
      return {
        ...prevState,
        start: pageNo,
        length: limit,
      };
    });
  };

  const handleDownload = async (filter: string) => {
    const appToken = localStorage.getItem("Apptoken") || "";
    const params: Record<string, any> = {
      ...(paginationStates.search === null
        ? {}
        : { search: paginationStates.search }),
    };
    const queryString = new URLSearchParams(params).toString();
    const apiEndpoint = `${BASE_URL}admin/api/getStpListExcel?${queryString}`;
    const fileName = "STP.xlsx";
    try {
      setdisabled(true);
      const response = await downloadExcelGet({
        apiEndpoint,
        appToken,
        fileName,
      });
      if (response.success) { 
        setdisabled(false);
      }
    } catch (error: any) {
      console.log("Error while downloading STP excel");
    } finally {
      setdisabled(false);
    }
  };

  return (
    <div className="p-4">
      <PageHeader
        title="STP"
        buttons={[
          {
            label: "Excel",
            onClick: () => handleDownload("Excel"),
            color: disable ? "#888" : "#43B9B2",
            disable: disable,
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={data?.data?.recordsTotal || 0}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="STP List"
        columns={STPListColumns(handleEditSTPColumns, handleView)}
        data={data?.data?.data || []}
      />
      <STPEditModal
        rowData={rowData}
        StpStatusData={data?.data?.StpStatusConfiq?.StpStatus || {}}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        title={"Edit STP"}
      />
    </div>
  );
};

export default STP;
